export default __webpack_public_path__ + "static/media/p.88e40f74.svg";